import React from 'react';
import './Blogs.css';
import ParticlesBg from 'particles-bg';


const Blogs = () => {
    return (
        <>
            <div className='mb-auto'>
                <div className="container my-4">
                    <div className="row">
                        <div className="col-md-4 col-sm-8 card-wrapper">
                            <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                                <div class="card card-block">
                                    <img src="https://brainhub.eu/blog/wp-content/uploads/2019/04/why-react-js.png" alt=" react reactjs javascript" />
                                    <h5 class="card-title mt-3 mb-3">Beginner's Guide to ReactJS</h5>
                                    <p>
                                        React uses javascript library to create efficient user interfaces of web application...
                                    </p>
                                    <a href="https://medium.com/@saakeeb/how-to-create-react-app-8f8b0b2e2ef8" class="btn btn-primary p-2 m-2" target="_blank" rel="noopener noreferrer">Read More</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-8 card-wrapper">
                            <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                                <div class="card card-block">
                                    <img src="https://miro.medium.com/max/1200/1*BIJR7LBDlkDjg9aHiR0ugA.png" alt=" react reactjs javascript" />
                                    <h5 class="card-title mt-3 mb-3">Getting Started with Firebase</h5>
                                    <p>
                                        If you ever heard a serverless project. Well there are many projects that...
                                    </p>
                                    <a href="https://medium.com/programming-note/creating-firebase-project-4caf98637e3b" class="btn btn-primary p-2 m-2" target="_blank" rel="noopener noreferrer">Read More</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-8 card-wrapper">
                            <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                                <div class="card card-block">
                                    <img src="https://miro.medium.com/max/955/1*RfmCwe3jNhoM7flnI3sDmw.jpeg" alt=" react reactjs javascript" />
                                    <h5 class="card-title mt-3 mb-3">Spread and Rest Operator in JavaScript</h5>
                                    <p>
                                        Sometimes, we may need to convert a String into a list of characters...
                                    </p>
                                    <a href="https://medium.com/programming-note/spread-operator-and-the-rest-operator-a77556af544e" class="btn btn-primary p-2 m-2" target="_blank" rel="noopener noreferrer">Read More</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 col-sm-8 card-wrapper">
                            <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1000" data-aos-easing="ease-in-sine">
                                <div class="card card-block">
                                    <img src="https://miro.medium.com/max/992/1*fCIv2orKflGWm-7EyKNG8w.png" alt=" react reactjs javascript" />
                                    <h5 class="card-title mt-3 mb-3">Fecli doesn’t install in the recent npm</h5>
                                    <p>
                                        NPM is a package manager for the JavaScript programming...
                                    </p>
                                    <a href="https://medium.com/programming-note/spread-operator-and-the-rest-operator-a77556af544e" class="btn btn-primary p-2 m-2" target="_blank" rel="noopener noreferrer">Read More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ParticlesBg num={20} type="cobweb" bg={true} />
        </>
    );
};

export default Blogs;